<template>
    <div class="page magic-bg dark:text-white">
        <navigation :key="navigationKey"/>
        <div class="bookmark">
            <div class="bookmark-container">
                <div class="bookmark-modal" id="user_list_adjustments">
                    <div class="flex flex-row items-center justify-between mb-2">
                        <p class="bookmark-modal-title text-gradient mr-auto">Сортировка</p>
                        <button class="rounded-button" title="Очистить сортировку" @click="ClearParams">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 hover:animate-spin" viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clip-rule="evenodd" />
                            </svg>
                        </button>
                    </div>
                    <div class="form-group ml-2 mt-2">
                        <label class="w-28">Поиск</label>
                        <input class="input sm:ml-2" type="text" v-model="search_param">
                    </div>
                    <p class="bookmark-modal-title text-gradient mr-auto">Инструменты</p>
                    <button class="mt-2 ml-2 mr-auto" @click="DonwloadList()">Cкачать журнал договоров</button>
                    <button class="mt-2 ml-2 mr-auto" @click="pageNumber = 0;_ProccessContracts()">Запросить данные заново</button>
                </div>
            </div>
            <div class="bookmark-navbar">
                <div class="bookmark-link" @click="$root.ToggleBookmark('#user_list_adjustments')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M5 4a1 1 0 00-2 0v7.268a2 2 0 000 3.464V16a1 1 0 102 0v-1.268a2 2 0 000-3.464V4zM11 4a1 1 0 10-2 0v1.268a2 2 0 000 3.464V16a1 1 0 102 0V8.732a2 2 0 000-3.464V4zM16 3a1 1 0 011 1v7.268a2 2 0 010 3.464V16a1 1 0 11-2 0v-1.268a2 2 0 010-3.464V4a1 1 0 011-1z" />
                    </svg>
                </div>
            </div>
        </div>
        <div class="flex flex-row items-end justify-between mt-4 w-[90%] max-w-4xl mx-auto fade">
            <div class="flex flex-row items-center justify-center background rounded-t-lg ml-3 py-2 px-3 fade">
                <p>С</p>
                <p class="ml-2">{{pageNumber * elementNumber + 1}}</p>
                <p class="ml-2">по</p>
                <p class="ml-2">{{pageNumber * elementNumber + contracts.length}}</p>
                <p class="ml-2"><b class="text-gradient">Всего:</b> {{contractCount}}</p>
            </div>
            <div class="flex flex-row items-center justify-center background rounded-t-lg mr-3 py-2 px-3 fade">
                <button @click="Back">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd" />
                    </svg>
                </button>
                <p>{{pageNumber + 1}}</p>
                <p class="ml-2">из</p>
                <p class="ml-2">{{pagesCount}}</p>
                <button @click="Forward">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
        </div>
        <div class="card py-0 w-[90%] max-w-4xl mx-auto overflow-auto fade" style="max-height: calc(100vh - 10rem)">
            <table class="sys-table mb-2">
                <thead>
                    <th>№</th>
                    <th v-if="$root.HasRole($store.state.adminRole)">ID</th>
                    <th>Номер</th>
                    <th>Дата</th>
                    <th>ФИО</th>
                    <th>Предмет договора</th>
                    <th></th>
                    <th></th>
                </thead>
                <tbody>
                    <tr v-for="(contract, index) in contracts" :key="index">
                        <th>{{pageNumber * elementNumber + index + 1}}</th>
                        <td class="text-center" v-if="$root.HasRole($store.state.adminRole)">{{contract.ID}}</td>
                        <td class="text-center">{{contract.Number}}</td>
                        <td class="text-center">{{contract.Date}}</td>
                        <td class="text-center">{{contract.User.FIO}}</td>
                        <td class="text-center">{{contract.Subject !== "" ? contract.Subject : "––//––"}}</td>
                        <th>
                            <button class="text-blue-600" @click="DownloadContract(contract.ID)">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                </svg>
                            </button>
                        </th>
                        <th>
                            <button class="text-red-600" @click="DeleteContract(contract.ID)">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
                                </svg>
                            </button>
                        </th>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import Navigation from '@/components/Navigation'

export default {
    components: {
        Navigation
    },
    data() {
        return {
            search_param: "",
            contracts: [],
            contractCount: 0,
            elementNumber: 25,
            pageNumber: 0,
            pagesCount: 0,
            navigationKey: "nav",
            title: "Список договоров"
        }
    },
    methods: {
        SetTitle() {
            document.title = `Samgk DPO - ${this.title}`
        },
        Forward() {
            this.pageNumber = this.pageNumber >= this.pagesCount - 1 ? 0 : this.pageNumber + 1
            this._ProccessContracts()
        },
        Back() {
            this.pageNumber = this.pageNumber <= 0 ? this.pagesCount - 1 : this.pageNumber - 1
            this._ProccessContracts()
        },
        ClearParams() {
            this.search_param = ""
        },
        async _ProccessContracts() {
            this.$root.StartLoading()

            var res = await fetch(this.$store.state.aeApiAddr + `/v1.0/journal_contracts/list?limit=${this.elementNumber}&skip=${this.pageNumber * this.elementNumber}&search=${this.search_param}`, {
                method: "GET",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                },
            }).then(response => {return response.json()})
            .catch(error => {
                this.$root.Fatal()
            })

            if (this.$root.HandleFetchError(res)) return

            this.contractCount = res.data.collections

            this.pagesCount = Math.ceil(this.contractCount / this.elementNumber)

            let contracts = []

            for (var i in res.data.contracts) {
                var contract = res.data.contracts[i]

                contracts.push({
                    ID: contract.id,
                    ProgramID: contract.program_id,
                    Number: contract.number,
                    Date: this.$root.FormatDate(contract.date),
                    User: {
                        ID: contract.user_id,
                        FIO: contract.fio
                    },
                    Subject: contract.subject
                })
            }

            this.contracts = contracts

            this.$root.EndLoading()
        },
        DeleteContract(id) {
            fetch(this.$store.state.aeApiAddr + "/v1.0/journal_contracts/", {
                method: "DELETE",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify({ id: id })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this.$root.ShowToast("Договор успешно удалён", "success")
                this._ProccessContracts()
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
        async DownloadContract(id) {
            try {
                var res = await fetch(this.$store.state.filesApiAddr + "/v1.0/ae/contracts/education_additional_general_development_program/by_id", {
                    method: "POST",
                    headers: {
                        'Authorization': `Bearer ${this.$root.GetToken()}`,
                        'Content-Type': 'text/json;charset=utf-8'
                    },
                    body: JSON.stringify({
                        id: id
                    })
                })
                .catch(error=> {
                    this.$root.ShowToast("Не удалось скачать договор", "error")
                })

                var result = await res.blob()

                var name = res.headers.get('Content-Disposition').split('filename=')[1].split('"')[1].replace("do-b", "до-б")

                var a = document.createElement("a")
                a.setAttribute("href", URL.createObjectURL(result))
                a.setAttribute("target", "_blank")
                a.setAttribute("download", name)
                document.body.appendChild(a)
                a.click()
                URL.revokeObjectURL(a.href)
                a.remove()
            } catch (e) {
                this.$root.ShowToast("Не удалось скачать договор", "error")
            }
        },
        async DonwloadList() {
            try {
                var res = await fetch(this.$store.state.filesApiAddr + "/v1.0/ae/contracts/download", {
                    method: "POST",
                    headers: {
                        'Authorization': `Bearer ${this.$root.GetToken()}`,
                        'Content-Type': 'text/json;charset=utf-8'
                    }
                })

                var result = await res.blob()

                var name = res.headers.get('Content-Disposition').split('filename=')[1].split('"')[1]

                var a = document.createElement("a")
                a.setAttribute("href", URL.createObjectURL(result))
                a.setAttribute("target", "_blank")
                a.setAttribute("download", name)
                document.body.appendChild(a)
                a.click()
                URL.revokeObjectURL(a.href)
                a.remove()
            } catch (e) {
                this.$root.ShowToast("Не удалось скачать журнал договоров", "error")
            }
        }
    },
    mounted() {
        if (this.$root.fatal) return
        this.SetTitle()
        this.$root.StartLoading()
        this.$root.UpdateToken()
        this.$root.GetRoles().then(()=>{
            if (!(this.$root.HasRole(this.$store.state.adminRole) || this.$root.HasRole(this.$store.state.methodistRole))) {
                this.$root.ShowToast("У вас нет прав на посещение данного раздела", "error", 8000)
                this.$router.push({name: 'Home'})
                return
            }
            this._ProccessContracts().then(()=>{
                this.$root.EndLoading()
            })
        })   
    }
}
</script>